<template>
  <div>
    <PageHeader :title="nameTitle" :items="headerItems" />
    <div style="border-radius: 5px; background-color: white; padding: 20px">
      <ReadOnly :componentData="mainData.first" />
      <div class="mt-4" style="border: 1px solid #f0f1f1; border-radius: 5px">
        <b-card-header header-tag="header" class="header" role="tab">
          <b-button @click="arrowToggle()" block v-b-toggle.crypto-details class="w-100 button">
            <div class="inlineButton">
              <div class="buttonTitle">{{ mainData.second.title }}</div>
              <div>
                <i :class="{ down: isToggled, up: !isToggled }"> </i>
              </div>
            </div>
          </b-button>
        </b-card-header>
        <b-collapse id="crypto-details" visible accordion="crypto-details" role="tabpanel">
          <b-card-body>
            <BaseText
              @input="mainData.second.data.persianCoinName = $event"
              :value="mainData.second.data.persianCoinName"
              title="نام ارز به فارسی"
              placeholder="نام ارز به فارسی"
            />
            <BaseText class="mt-3" @input="mainData.second.data.buyLimitation = $event" :value="mainData.second.data.buyLimitation" title="حداقل خرید" placeholder="حداقل خرید" />
            <TagComboBox :searchedData="mainData.second.data.networks" :selectedValue="selectedNetworks" class="mt-3" title="شبکه ها" placeholder="شبکه ها" />
            <ComboBox
              class="mt-3"
              :searchedData="mainData.second.data.networks"
              @selectedItem="selectNetwork($event)"
              :selectedValue="selectedNetwork"
              placeholder="شبکه پیش فرض"
              title="شبکه پیش فرض"
            />
            <ColorPicker class="mt-3" @input="mainData.second.data.color = $event" labelClass="addColorClass" :value="mainData.second.data.color" title="رنگ" />
            <BaseText
              class="mt-3"
              @input="mainData.second.data.suggestedWallet = $event"
              :value="mainData.second.data.suggestedWallet"
              title="کیف پول پیشنهادی"
              placeholder="کیف پول پیشنهادی"
            />
            <BaseText
              class="mt-3"
              labelClass="labelClass"
              @input="mainData.second.data.cryptoAddress = $event"
              :value="mainData.second.data.cryptoAddress"
              title="آدرس صفحه کیف پول"
              placeholder="آدرس صفحه کیف پول"
            />
            <BaseText
              class="mt-3"
              labelClass="labelClass"
              @input="mainData.second.data.explorer = $event"
              :value="mainData.second.data.explorer"
              title="اکسپلورر"
              placeholder="اکسپلورر"
            />
            <BaseText
              class="mt-3"
              labelClass="labelClass"
              @input="mainData.second.data.decimalNumber = $event"
              :value="mainData.second.data.decimalNumber"
              title="تعداد اعشار مجاز"
              placeholder="تعداد اعشار مجاز"
            />
            <ComboBox
              class="mt-3"
              @selectedItem="selectStatus($event)"
              :selectedValue="mainData.second.data.status ? 'فعال' : 'غیرفعال'"
              :searchedData="statusData"
              placeholder="وضعیت"
              title="وضعیت"
            />
            <ComboBox
              class="mt-3"
              @selectedItem="selectBuyStatus($event)"
              :selectedValue="mainData.second.data.buyStatus ? 'فعال' : 'غیرفعال'"
              :searchedData="statusData"
              placeholder="وضعیت خرید"
              title="وضعیت خرید"
            />
            <ComboBox
              class="mt-3"
              @selectedItem="selectSellStatus($event)"
              :selectedValue="mainData.second.data.sellStatus ? 'فعال' : 'غیرفعال'"
              :searchedData="statusData"
              placeholder="وضعیت فروش"
              title="وضعیت فروش"
            />
            <b-row class="mt-3">
              <b-col cols="3">
                <ChooseImage
                  :defaultImage="mainData.second.data.coinImage"
                  :isUser="true"
                  :imageCropperModal="imageCropperModal"
                  :cropperLoading="cropperLoading"
                  @productImage="userImage($event)"
                />
              </b-col>
              <b-col class="d-flex align-items-center justify-content-between" cols="9">
                <div v-for="coin in mainData.second.data.coinStatus" :key="coin.id">
                  <b-form-checkbox :id="coin.id" v-model="deactiveUserStatus" @change="deactiveUser" name="checkbox-1"> غیرفعال کردن ارز </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
            <div class="button-wrapper mt-3">
              <div @click="goBack()" class="me-2">
                <Button text="انصراف" btnClass="cancel btn-border" />
              </div>
              <div @click="editCryptoDetails()">
                <Button :loading="companyLoading" text="ثبت" btnClass="aprove-btn btn-border" />
              </div>
            </div>
          </b-card-body>
        </b-collapse>
        <Toast title="با موفقیت ثبت شد" submit :showToast="showToast" />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/layoutComponents/page-header'
import ReadOnly from '../common/form/type/ReadOnly.vue'
import walletDataProvider from '../../services/wallet'
import BaseText from '../common/form/formModules/BaseText.vue'
import TagComboBox from '../common/form/formModules/TagComboBox.vue'
import ComboBox from '../common/form/formModules/ComboBox.vue'
import ColorPicker from '../common/form/formModules/colorPicker.vue'
import ChooseImage from '../common/form/formModules/ChooseImage.vue'
import fileMannager from '../../services/file'
import Button from '../common/Button.vue'
import Toast from '../common/Toast.vue'

export default {
  name: 'crypto-transaction',
  components: {
    PageHeader,
    ReadOnly,
    BaseText,
    TagComboBox,
    ComboBox,
    ColorPicker,
    ChooseImage,
    Button,
    Toast,
  },
  data() {
    return {
      selectedNetwork: '',
      mainData: [],
      showToast: false,
      selectedNetworks: [],
      cropperLoading: false,
      imageCropperModal: false,
      statusData: [
        { key: true, value: 'فعال' },
        { key: false, value: 'غیرفعال' },
      ],
    }
  },
  computed: {
    nameTitle() {
      return 'مدیریت ارزها'
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: this.nameTitle,
          active: true,
        },
      ]
    },
    cryptoId() {
      return this.$route.params.id
    },
  },
  methods: {
    arrowToggle() {
      return (this.isToggled = !this.isToggled)
    },
    selectStatus(payload) {
      this.mainData.second.data.status = payload.key
    },
    selectBuyStatus(payload) {
      this.mainData.second.data.buyStatus = payload.key
    },
    selectSellStatus(payload) {
      this.mainData.second.data.sellStatus = payload.key
    },
    selectNetwork(payload) {
      this.mainData.second.data.defaultNetwork = payload.value
      this.selectedNetwork = payload.value
    },
    editCryptoDetails() {
      let myNetworks = ''
      for (let i = 0; i < this.selectedNetworks.length; i++) {
        const element = this.selectedNetworks[i]
        myNetworks += element.value + (i != this.selectedNetworks.length - 1 ? ',' : '')
      }
      let targetData = {
        coin: this.$route.params.id,
        persianCoinName: this.mainData.second.data.persianCoinName,
        buyLimitation: this.mainData.second.data.buyLimitation,
        defaultNetwork: this.mainData.second.data.defaultNetwork,
        networks: myNetworks,
        color: this.mainData.second.data.color,
        explorer: this.mainData.second.data.explorer,
        cryptoAddress: this.mainData.second.data.cryptoAddress,
        decimalNumber: this.mainData.second.data.decimalNumber,
        status: this.mainData.second.data.status,
        buyStatus: this.mainData.second.data.buyStatus,
        sellStatus: this.mainData.second.data.sellStatus,
        coinImage: this.mainData.second.data.coinImage,
        suggestedWallet: this.mainData.second.data.suggestedWallet,
      }
      walletDataProvider.editCryptoCurrencyDetail(targetData).then((res) => {
        this.showToast = true
        setTimeout(() => {
          this.showToast = false
          this.$router.go(-1)
        }, 2000)
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    getData(payload) {
      walletDataProvider
        .getCryptoDetails(payload)
        .then((res) => {
          this.mainData = res.data.data
          this.selectedNetwork = res.data.data.second.data.networks.find((net) => net.value == res.data.data.second.data.defaultNetwork).value
          for (let i = 0; i < res.data.data.second.data.networks.length; i++) {
            let element = res.data.data.second.data.networks[i]
            if (element.isEnable == true) {
              this.selectedNetworks.push(element)
            }
          }
          this.mainData.first.id = '69'
        })
        .catch((err) => console.log(err))
    },
    userImage(event) {
      this.cropperLoading = true
      this.imageCropperModal = true
      const selectedImage = event
      fileMannager
        .addImage({ base64image: selectedImage })
        .then((res) => {
          this.cropperLoading = false
          this.imageCropperModal = false
          this.mainData.second.data.coinImage = res.data.data.downloadUrl
        })
        .catch((err) => {
          alert('مجددا تلاش کنید.')
        })
    },
  },
  beforeMount() {
    this.getData({ coin: this.cryptoId })
  },
}
</script>

<style scoped lang="scss">
.team-task-detail-header {
  width: 100%;
  position: sticky;
  top: 60px;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8fb;
}
::v-deep .collapse .card-body {
  background-color: #ffffff !important;
}
::v-deep .aprove {
  padding: 3px 14px !important;
  background-color: #556ee6 !important;
  width: 119px !important;
  margin-right: 22px !important;
}
::v-deep .user-style {
  align-items: center !important;
}
::v-deep .labelStyle {
  min-width: 117px !important;
  max-width: 117px !important;
}
.collapse .card-body {
  background-color: #ffffff;
}
.buttonClass {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  direction: ltr;
}
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.cancel {
  background-color: rgba(51, 51, 51, 0.6) !important;
}
.btn-border {
  border-radius: 4px !important;
}
::v-deep .aprove-btn {
  background-color: #556ee6 !important;
  width: 119px !important;
}
.header {
  padding: 0;
  background: #f8f9fa;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
  border-radius: 5px 5px 0 0;
  width: 100%;
}
.button {
  padding: 11px 20px;
  box-shadow: none;
  border: none;
  background: #f8f9fa;
}
.labelClass {
  font-size: 10px !important;
}
::v-deep .collapsed {
  outline: none;
  border: none;
  background: #fafafa;
}
::v-deep .card-body {
  padding: 20px !important;
}
.buttonTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #444444;
}
.collapse {
  border-top: none;
}
::v-deep .alert {
  padding: 0;
}
.inlineButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
i {
  border: solid #555555;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
}
.down {
  transform: rotate(-135deg);
}
.up {
  transform: rotate(45deg);
}
</style>
